import React from 'react';
import TaskDetail from "./TaskDetail";
import TaskEdit from "./TaskEdit";
import {Route} from "react-router";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import {getTask} from "../../../actions/tasks";

class Task extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/tasks/:taskId" component={TaskDetail}/>
        <Route path="/projects/:id/tasks/:taskId/edit" component={TaskEdit}/>
      </div>
    );
  }
}

const TaskBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/tasks/`, resource: props.task.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const task = state.view.subview.data[props.match.params.taskId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'tasks', props.match.params.taskId];
      if (!compArr(path, itempath) || loading || !task) return { loading: true };
      return { task, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'tasks', props.match.params.taskId])),
      loader: () => dispatch(getTask(props.match.params.id, props.match.params.taskId)),
    })),
  withLoading404,
  withBreadcrumbCurried(TaskBreadcrumb),
)(Task);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/Task.js